import { useCallback } from "react";
import { useCachedQuery } from "./useCachedQuery";
import { fetchUsageHistory, type TenantUsageHistory } from "./useAdminStatus";
import { instanceUsageResource } from "../lib/adminQueries";
import { rangeToWindowHours, type InstanceRange } from "../lib/instanceDetailRange";

export type InstanceUsageResult = {
  status: "loading" | "ready" | "error";
  usage: TenantUsageHistory | null;
  error: string | null;
  isFetching: boolean;
};

export const useInstanceUsage = (tenantId: string, range: InstanceRange): InstanceUsageResult => {
  const hours = rangeToWindowHours(range);
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<TenantUsageHistory> => fetchUsageHistory(tenantId, hours, signal),
    [tenantId, hours],
  );
  const { status, data, error, isFetching } = useCachedQuery<TenantUsageHistory>({
    cacheResource: range === "24h" ? instanceUsageResource(tenantId) : null,
    queryKey: `/api/admin/claws/${tenantId}/usage-history?hours=${hours}`,
    fetcher,
  });
  return { status, usage: data, error, isFetching };
};
